import type { VehicleShapeDefinition } from './vehicleShape';

/**
 * Log stacker vehicle
 * Specialized for stacking and organizing logs
 */
export const logStackerShape: VehicleShapeDefinition = {
  vehicle: 'log_stacker',
  coordinateSystem: '2D',
  unit: 'normalized_percent',
  polygons: {
    body: [
      [25, 40],
      [75, 40],
      [75, 140],
      [25, 140],
    ],
    // Front left wheel
    wheel1: [
      [15, 44],
      [25, 44],
      [25, 69],
      [15, 69],
    ],
    // Front right wheel
    wheel2: [
      [75, 44],
      [85, 44],
      [85, 69],
      [75, 69],
    ],
    // Rear left wheel
    wheel3: [
      [15, 114],
      [25, 114],
      [25, 139],
      [15, 139],
    ],
    // Rear right wheel
    wheel4: [
      [75, 114],
      [85, 114],
      [85, 139],
      [75, 139],
    ],
    connector1: [
      [32, 15],
      [38, 15],
      [38, 120],
      [32, 120],
    ],
    connector2: [
      [62, 15],
      [68, 15],
      [68, 120],
      [62, 120],
    ],
    // Grapple at the front, connecting with both connectors
    grapple: [
      [10, 20],
      [50, 0],
      [90, 20],
      [50, 12],
    ],
  },
  colorConfig: {
    body: { type: 'dynamic' }, // Uses vehicle color
    wheel1: { type: 'fixed', color: '#000000' },
    wheel2: { type: 'fixed', color: '#000000' },
    wheel3: { type: 'fixed', color: '#000000' },
    wheel4: { type: 'fixed', color: '#000000' },
    connector1: { type: 'fixed', color: '#000000' },
    connector2: { type: 'fixed', color: '#000000' },
    grapple: { type: 'fixed', color: '#000000' },
  },
};
